module.exports = __webpack_public_path__ + "static/media/karma-sherpa.8e261148.jpg";